import { render, staticRenderFns } from "./SourceManage.vue?vue&type=template&id=54ade45e&"
import script from "./SourceManage.vue?vue&type=script&lang=js&"
export * from "./SourceManage.vue?vue&type=script&lang=js&"
import style0 from "./SourceManage.vue?vue&type=style&index=0&lang=scss&module=s&"
import style1 from "./SourceManage.vue?vue&type=style&index=1&lang=scss&"




function injectStyles (context) {
  
  this["s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports